import { Router } from 'director/build/director';
import routes from './routes';
import ErrorPage from './scenes/Error/Error';
import './index.css';
import './media/css/page.css';

import './media/css/bootstrap.css';
import './media/css/font-awesome.css';

const router = Router(routes).configure({
  html5History: true,
  run_handler_in_init: true,
  notfound: () => ErrorPage('Page not found'),
});

router.init('/');



// WEBPACK FOOTER //
// ./src/index.js